import { ORDER_TIME_OPTIONS } from '../../../../../modals/order-method/useOrderTimeOptions';
import { DropoffAction, ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  sections: {
    order_method: {
      titles: {
        [ORDER_METHODS.PICKUP]: 'Recogida',
        [ORDER_METHODS.DELIVERY]: 'Entrega',
        [ORDER_METHODS.ON_SITE]: 'Pedido en mesa',
      },
    },
    delivery_info: {
      title: 'Detalles de entrega',
      on_arrival: 'A la llegada:',
    },
    customer_info: {
      title: 'Contacto',
    },
    payment: {
      title: 'Pago',
    },
    request_invoice: {
      title: 'Solicitar factura',
      form: {
        is_receipt_required: {
          label: 'Solicitar factura por email',
        },
      },
    },
    location: {
      title: 'Dirección del establecimiento',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Dirección de entrega',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Tu mesa',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Dirección de recogida',
      },
    },
    method: {
      title: 'Método',
      [ORDER_METHODS.DELIVERY]: {
        title: 'Entrega',
      },
      [ORDER_METHODS.ON_SITE]: {
        title: 'Pedido en mesa',
      },
      [ORDER_METHODS.PICKUP]: {
        title: 'Recogida',
      },
    },
    time: {
      title: 'Hora',
      method: {
        [ORDER_TIME_OPTIONS.asap]: {
          title: 'Estándar {{time}} min, hoy',
        },
        [ORDER_TIME_OPTIONS.scheduled]: {
          title: 'Programar para más tarde',
        },
      },
    },
  },
  form: {
    dropoff_action: {
      options: {
        [DropoffAction.RingDoorBell]: 'Llamar al timbre',
        [DropoffAction.Sms]: 'Contactarme por SMS al llegar',
      },
    },
    doorbell_name: {
      placeholder: 'Nombre del timbre (opcional)',
    },
    company_name: {
      placeholder: 'Nombre de empresa (opcional)',
    },
    customer_note: {
      placeholder: '¿Alguna nota para el restaurante?',
    },
  },
  buttons: {
    change: 'Cambiar',
    edit: 'Editar',
    done: 'Listo',
    add_delivery_note: '+ Añadir detalles de entrega',
    add_order_note: '+ Añadir nota al pedido',
  },
  summary: {
    doorbell: 'Timbre',
    company: 'Empresa',
    note: 'Nota del pedido',
  },
};
